module.exports = __webpack_public_path__ + "img/spotify-web.8195514f.png";